<template>
  <div>
    <h2 class="mb-4">บทความ RFB3 {{ search.page }}</h2>
    <CRow>
      <CCol :md="{ size: '7', offset: '5' }" class="text-right mb-2">
        <CRow :gutters="false">
          <CCol :md="{ size: '3', offset: '1' }">
            <CInput
              v-model="word"
              placeholder="ค้นหา"
              :horizontal="{ input: 'col-12' }"
            />
          </CCol>
          <CCol md="3">
            <CSelect
              :value.sync="filterSelected"
              :options="filter"
              class="ml-2"
            />
          </CCol>
          <CCol md="5">
            <div class="flex space-between">
              <CButton color="primary" class="ml-2" @click="handleSearch"
                ><i class="fas fa-search"></i> ค้นหา
              </CButton>
              <vue-excel-xlsx
                :data="rows"
                :columns="columns"
                :filename="'filename'"
                :sheetname="'sheetname'"
              >
                <CButton color="info">
                  <i class="far fa-file-excel"></i> Excel download
                </CButton>
              </vue-excel-xlsx>
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <CRow>
      <CCol col="12">
        <vue-good-table
          mode="remote"
          :isLoading.sync="loading"
          :columns="columns"
          :rows="rows"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'createdAt', type: 'desc' }
          }"
          @on-sort-change="onSortChange"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'audio'">
              <audio controls style="width: 220px;">
                <source :src="props.row.audio" />
                Your browser does not support the audio element.
              </audio>
            </span>
            <span v-else-if="props.column.field == 'createdAt'">
              {{ props.row.createdAt | datetimeFormat }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
      <CCol col="12">
        <vue-ads-pagination
          :total-items="total"
          :max-visible-pages="5"
          :items-per-page="10"
          :page="search.page"
          :loading="loading"
        >
          <template slot-scope="props">
            <div class="vue-ads-pr-2 vue-ads-leading-loose">
              รายการที่ {{ props.start | decimalFormat }} ถึง
              {{ props.end | decimalFormat }} จาก
              {{ props.total | decimalFormat }} รายการ
            </div>
          </template>
          <template slot="buttons" slot-scope="props">
            <vue-ads-page-button
              v-for="(button, key) in props.buttons"
              :key="key"
              v-bind="button"
              @page-change="pageChange(button.page)"
            />
          </template>
        </vue-ads-pagination>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import apiRfb3 from '@/apis/rfb3'

import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination'

export default {
  name: 'Rfb3',
  components: {
    VueAdsPagination,
    VueAdsPageButton
  },
  data() {
    return {
      loading: false,
      word: '',
      search: {},
      defaultSearch: {
        name: null,
        detail: null,
        readerFirstname: null,
        readerLastname: null,
        page: 0,
        limit: 10,
        sort: {
          field: 'createdAt',
          type: 'desc'
        }
      },
      total: 0,
      filterSelected: 'name',
      filter: [
        { value: 'name', label: 'ชื่อบทความ' },
        { value: 'detail', label: 'ที่มา' },
        { value: 'readerFirstname', label: 'ชื่อผู้อ่าน' },
        { value: 'readerLastname', label: 'นามสกุลผู้อ่าน' }
      ],
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ชื่อบทความ',
          field: 'name',
          width: '180px',
          tdClass: 'width-180'
        },
        {
          label: 'ที่มา',
          field: 'detail',
          width: '180px',
          tdClass: 'width-180'
        },
        {
          label: 'ชื่อ - นามสกุลผู้อ่าน',
          field: 'firstName',
          width: '180px',
          tdClass: 'width-180'
        },
        {
          label: 'หมวดหมู่',
          field: 'category'
        },
        {
          label: 'วันเวลาที่สร้าง',
          field: 'createdAt',
        },
        {
          label: 'ทดลองฟัง',
          field: 'audio',
          sortable: false
        }
      ],
      rows: []
    }
  },
  created() {
    this.search = Object.assign({}, this.defaultSearch)
  },
  methods: {
    handleSearch() {
      this.search = Object.assign({}, this.defaultSearch)
      if (this.word) this.search[this.filterSelected] = this.word

      this.getList()
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    onSortChange(params) {
      this.search.sort = params[0]
      this.getList()
    },
    getList() {
      this.loading = true

      apiRfb3
        .getList(this.search)
        .then((result) => {
          this.total = result.data.totalDocs
          this.rows = []
          for (let i = 0; i < result.data.docs.length; i++) {
            const item = result.data.docs[i]

            this.rows.push({
              no: (this.search.page * this.search.limit) + i + 1,
              name: item.book.name,
              detail: item.book.detail,
              firstName: item.user.fullName,
              category: item.book.category.nameTh,
              createdAt: item.createdAt,
              audio: item.soundUrl
            })
          }

          this.loading = false
        })
        .catch(() => {
          this.rows = []
          this.loading = false
        })
    }
  }
}
</script>
